var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0C3.34375 0 3.65625 0.28125 3.71875 0.625L3.78125 1H16.9062C17.5625 1 18.0625 1.65625 17.875 2.28125L16.1875 8.28125C16.0625 8.71875 15.6875 9 15.2188 9H5.3125L5.59375 10.5H15.25C15.6562 10.5 16 10.8438 16 11.25C16 11.6875 15.6562 12 15.25 12H4.96875C4.625 12 4.3125 11.75 4.25 11.4062L2.375 1.5H0.75C0.3125 1.5 0 1.1875 0 0.75C0 0.34375 0.3125 0 0.75 0H3ZM14.8438 7.5L16.25 2.5H4.09375L5.03125 7.5H14.8438ZM4 14.5C4 13.6875 4.65625 13 5.5 13C6.3125 13 7 13.6875 7 14.5C7 15.3438 6.3125 16 5.5 16C4.65625 16 4 15.3438 4 14.5ZM16 14.5C16 15.3438 15.3125 16 14.5 16C13.6562 16 13 15.3438 13 14.5C13 13.6875 13.6562 13 14.5 13C15.3125 13 16 13.6875 16 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCartWhite);
export default __webpack_public_path__ + "static/media/AddToCartWhite.0f47f0a7183dbba7bf9a3f79dc04fa8b.svg";
export { ForwardRef as ReactComponent };